import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Rating from '@mui/material/Rating';

const getInitials = (name) => (name || '')
  .trim()
  .split(/\s+/)
  .slice(0, 2)
  .map((word) => word[0])
  .join('')
  .toUpperCase();

const logoClass = 'h-16 w-16 shrink-0 rounded-2xl bg-white shadow-md ring-1 ring-black/5 sm:h-24 sm:w-24';

const Address = ({ data }) => {
  // Fall back to company initials when the logo is missing or fails to load
  const [logoFailed, setLogoFailed] = useState(false);

  useEffect(() => {
    setLogoFailed(false);
  }, [data?.logo]);

  const hasLogo = data && data.logo !== null && data.logo !== '';

  return (
    <div className="flex flex-col gap-4 px-5 py-5 sm:flex-row sm:items-center sm:justify-between sm:px-8 sm:py-6">
      <div className="min-w-0">
        <div className="flex items-center gap-4 sm:gap-6">
          {hasLogo && !logoFailed && (
          <img
            className={`${logoClass} object-cover`}
            src={data.logo}
            alt="logo"
            onError={() => setLogoFailed(true)}
          />
          )}
          {(!hasLogo || logoFailed) && data?.company?.name && (
          <div className={`${logoClass} flex items-center justify-center text-xl font-medium text-slate-600`}>
            {getInitials(data?.company?.name)}
          </div>
          )}
          <div className="min-w-0">
            <div className="text-xl font-semibold tracking-tight text-slate-900 sm:text-2xl">
              {data?.company?.name}
            </div>
            <div className="mt-1.5 items-center gap-2 sm:flex">
              <div className="mr-2 flex items-center">
                <div className="mr-1.5 text-[15px] text-[#f57c00]">{Math.round((data.rating_average) * 10) / 10}</div>
                <div>
                  <Rating
                    name="read-only" 
                    sx={{ fontSize: '13px' }}
                    value={Math.round((data.rating_average) * 10) / 10}
                    readOnly
                  />
                </div>          
              </div>
              <div className="mt-1 text-xs text-slate-500 sm:mt-0 sm:text-sm">
                <span className="text-slate-700">
                  {data?.review_count} 
                  {' '}
                  {' '}
                  reviews
                </span>
            
                {' | '}
                {data?.address?.street_address} 
                {' | '}
                {' '}
                {data?.address?.state_or_province} 
                {' '}
                {data?.address?.country}
              </div>
            
            </div>
          </div>
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-3">
        <div
          className="flex h-10 w-10 items-center justify-center rounded-xl bg-white p-2 ring-1 ring-slate-200 transition hover:-translate-y-0.5 hover:shadow-md"
          onClick={() => {
            if (data?.google !== null) {
              window.open(data?.google, '_blank', 'noopener,noreferrer');
            }
          }}
        >
          <img 
            src="/google.png"
            alt="google"
            className={`h-full w-full object-contain ${data?.google ? 'cursor-pointer' : ''}`}
          />
        </div>
        <div
          className="flex h-10 w-10 items-center justify-center rounded-xl bg-white p-2 ring-1 ring-slate-200 transition hover:-translate-y-0.5 hover:shadow-md"
          onClick={() => {
            if (data?.facebook !== null) {
              window.open(data?.facebook, '_blank', 'noopener,noreferrer');
            }
          }}
        >
          <img 
            src="/facebook.png"
            alt="facebook"
            className={`h-full w-full object-contain ${data?.facebook ? 'cursor-pointer' : ''}`}
          />
        </div>
        <div
          className="flex h-10 w-10 items-center justify-center rounded-xl bg-white p-2 ring-1 ring-slate-200 transition hover:-translate-y-0.5 hover:shadow-md"
          onClick={() => {
            if (data?.instagram !== null) {
              window.open(data?.instagram, '_blank', 'noopener,noreferrer');
            }
          }}
        >
          <img 
            src="/instagram.png"
            alt="instagram"
            className={`h-full w-full object-contain ${data?.instagram ? 'cursor-pointer' : ''}`}
          />
        </div>
        <div
          className="flex h-10 w-10 items-center justify-center rounded-xl bg-white p-2 ring-1 ring-slate-200 transition hover:-translate-y-0.5 hover:shadow-md"
          onClick={() => {
            if (data?.twitter !== null) {
              window.open(data?.twitter, '_blank', 'noopener,noreferrer');
            }
          }}
        >
          <img 
            src="/twitter.png"
            alt="twitter"
            className={`h-full w-full object-contain ${data?.twitter ? 'cursor-pointer' : ''}`}
          />
        </div>
      </div>
    </div>
  );
};

export default Address;
